module.exports = __webpack_public_path__ + "img/symbol_4.7fdbddd9.png";